<mat-card >
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-users fa-2x"></i></div>
    <mat-card-title>{{ 'provider' | human : null: null: 'plural' }}</mat-card-title>
    <mat-card-subtitle>Administre la información de los {{ 'provider' | human : null: null: 'plural' }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <ngx-crud-manager [service]="providersService" [itemTemplate]="itemTemplate" [formTemplate]="formTemplate" [formGroup]="form" (closedFormDialog)="onDialogClosed()">
      <ng-template #itemTemplate let-item>
        {{item.name}}
      </ng-template>
      <ng-template #formTemplate let-fform="form" let-value="value">
        <form [formGroup]="fform">
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Rut</mat-label>
            <input matInput appIdentifier formControlName="rut" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Teléfono</mat-label>
            <input matInput formControlName="phone" autocomplete="off" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Dirección</mat-label>
            <input matInput formControlName="address" autocomplete="off" required>
          </mat-form-field>
          </form>
          <br />

          <div class="row">
            <div class="subtitle">Datos de Pago</div>
          </div>
          <mat-form-field>
            <mat-label>{{ 'payment_method' | human }}</mat-label>
            <mat-select 
              aria-label="Método de Pago"
              formControlName="payment_method"  
            >
              <mat-option value="cash">Efectivo</mat-option>
              <mat-option value="credit_card">Tarjeta de Crédito</mat-option>
              <mat-option value="debit_card">Tarjeta de Débito</mat-option>
              <mat-option value="transfer">Transferencia</mat-option>
              <mat-option value="cheque">Cheque</mat-option>
            </mat-select>
          </mat-form-field>
          @if (this.form.get('payment_method').value === 'transfer') {
            <mat-form-field>
              <mat-label>Banco</mat-label>
              <input matInput formControlName="bank_name">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Tipo de cuenta bancaria</mat-label>
              <mat-select formControlName="bank_account_type">
                <mat-option value="checking">Corriente</mat-option>
                <mat-option value="savings">Ahorro</mat-option>
                <mat-option value="vista">Vista</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Número de cuenta bancaria</mat-label>
              <input matInput formControlName="bank_account_number">
            </mat-form-field>
          }

          @if (value) {
            <div class="row">
              <div class="subtitle">Dirección de Facturación</div>
            </div>
            <app-billing-info-form
              [entity]="value"
              entity_type="Provider"
            ></app-billing-info-form>
             
          }
          <div class="row">
            <div class="subtitle">Logo</div>
          </div>
          <input type="file" (change)="onFileSelected($event)" />
          <br />
          @if (previewUrl()) {
            <img [src]="previewUrl()" alt="Image Preview" width="150" height="150" style="object-fit: cover; border-radius: 8px;"/>
          } @else if (value?.picture) {
            <img src="{{value.picture}}" alt="Provider Image" width="150" height="150" style="object-fit: cover; border-radius: 8px;"/>
          }
        </ng-template>
    </ngx-crud-manager>
  </mat-card-content>
</mat-card>
